/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.0074 18.2695c.6589-.0015 1.3174-.1983 1.8739-.5904l9.1611-6.4546c1.2768-.8996 1.2768-2.7148 0-3.6144l-9.1611-6.4546c-1.1173-.7872-2.6453-.7872-3.7626 0L.9576 7.6101c-1.2768.8996-1.2768 2.7148 0 3.6144l9.1611 6.4546c.5565.3921 1.215.5889 1.8739.5904h.0148Zm-.0035-16.2044c.3294.0008.6585.0992.9368.2952l9.1611 6.4546c.4256.2999.4256.905 0 1.2048l-9.1611 6.4546c-.2783.196-.6074.2944-.9368.2952h-.0078c-.3294-.0008-.6585-.0992-.9368-.2952l-9.161-6.4546c-.4257-.2999-.4257-.905 0-1.2048l9.161-6.4546c.2783-.196.6074-.2944.9368-.2952h.0078Zm.0108 20.908c.8219-.0028 1.6431-.2488 2.3375-.738l8.8216-6.2154c.3503-.2468.4236-.7165.1639-1.0492-.2598-.3327-.7543-.4024-1.1045-.1556l-8.8217 6.2154c-.4174.2941-.9111.4417-1.4052.4428a.2243.2243 0 0 1-.0116 0c-.4941-.0011-.9879-.1487-1.4052-.4428l-8.8217-6.2154c-.3502-.2468-.8447-.1771-1.1045.1556-.2598.3327-.1864.8024.1638 1.0492l8.8217 6.2154c.6943.4892 1.5155.7352 2.3375.738h.0284Zm-10.323-8.1792a.002.002 0 0 0-.0007-.0004l-.4451.6318.4451-.6318.0007.0004Z"
    clipRule="evenodd"
  />,
  'Resource'
);
